import { render, staticRenderFns } from "./ItemsRentalTotalization.vue?vue&type=template&id=6f647b10&scoped=true&"
import script from "./ItemsRentalTotalization.vue?vue&type=script&lang=js&"
export * from "./ItemsRentalTotalization.vue?vue&type=script&lang=js&"
import style0 from "./ItemsRentalTotalization.vue?vue&type=style&index=0&id=6f647b10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f647b10",
  null
  
)

export default component.exports